import { Links } from 'constants/link'

import { useClearPrepareAirdropData } from 'state/airdrop/hooks'

import { Icon } from 'components/ui'
import { StyledLink, LogoSpan, IconWrapper, IconWeb } from './Style'

function LogoLink() {
  const clearPrepareAirdropData = useClearPrepareAirdropData()

  const handleResetState = () => {
    clearPrepareAirdropData()
  }

  return (
    <StyledLink to={Links.TOKEN} onClick={handleResetState} aria-label='Logo _mad-assembly'>
      <LogoSpan role='none'>_mad-assembly</LogoSpan>
      <IconWrapper>
        <Icon name='logoFull' size='fill' />
      </IconWrapper>
      <IconWeb>
        <Icon name='web' size='fill' rotate='180deg' />
      </IconWeb>
    </StyledLink>
  )
}

export { LogoLink }
